import { render, staticRenderFns } from "./DenunciaForm.vue?vue&type=template&id=5ac15d90&scoped=true"
import script from "./DenunciaForm.vue?vue&type=script&lang=js"
export * from "./DenunciaForm.vue?vue&type=script&lang=js"
import style0 from "./DenunciaForm.vue?vue&type=style&index=0&id=5ac15d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac15d90",
  null
  
)

export default component.exports